import Widget from 'models/dashboard/widget'

Widget.TrendingTopicsWidget = Widget.extend({
});

export default Widget.TrendingTopicsWidget;

